// import React, { useState, useEffect } from 'react';
// import { ChevronRight, Phone, Mail, MapPin, Clock, Menu, X, ChevronDown } from 'lucide-react';

// const Header = () => {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);

//   const services = [
//     { name: 'Chest X-Ray', path: '/services/chest-xray' },
//     { name: 'PFT', path: '/services/pft' },
//     { name: 'ECG', path: '/services/ecg' },
//     { name: '2D ECHO', path: '/services/2d-echo' },
//     { name: 'Allergy Testing', path: '/services/allergy-testing' },
//     { name: 'Bronchoscopy', path: '/services/bronchoscopy' },
//     { name: 'Thoracoscopy', path: '/services/thoracoscopy' }
//   ];

//   const procedures = [
//     { name: 'Asthma', path: '/procedures/asthma' },
//     { name: 'Allergies', path: '/procedures/allergies' },
//     { name: 'Snoring', path: '/procedures/snoring' },
//     { name: 'Adenoids', path: '/procedures/adenoids' },
//     { name: 'Tonsils', path: '/procedures/tonsils' },
//     { name: 'Sinusitis', path: '/procedures/sinusitis' },
//     { name: 'COPD', path: '/procedures/copd' },
//     { name: 'ILD', path: '/procedures/ild' },
//     { name: 'Obesity', path: '/procedures/obesity' },
//     { name: 'T.B', path: '/procedures/tb' },
//     { name: 'Lung Cancer', path: '/procedures/lung-cancer' },
//     { name: 'Other Services On Request', path: '/procedures/other-services' }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
//         :root {
//           --primary-orange: #E86A33;
//           --primary-blue: #1B4965;
//           --accent-blue: #2C5F7C;
//           --light-blue: #62B6CB;
//           --orange-light: #FF9B6E;
//           --text-dark: #1a1a1a;
//           --text-light: #666;
//           --bg-light: #F8FAFB;
//         }

//         .header {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           z-index: 1000;
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           background: white;
//           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
//         }

//         .header.scrolled {
//           background: rgba(255, 255, 255, 0.98);
//           backdrop-filter: blur(20px);
//           box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
//         }

//         .header-top {
//           background: linear-gradient(135deg, #1B4965, #2C5F7C);
//           padding: 0.8rem 0;
//           color: white;
//           font-size: 0.85rem;
//         }

//         .header.scrolled .header-top {
//           display: none;
//         }

//         .header-top-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 1rem;
//         }

//         .header-contact {
//           display: flex;
//           gap: 2rem;
//           align-items: center;
//         }

//         .contact-item {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .header-main {
//           padding: 1.2rem 0;
//           transition: padding 0.4s ease;
//         }

//         .header.scrolled .header-main {
//           padding: 0.8rem 0;
//         }

//         .header-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           text-decoration: none;
//           transition: transform 0.3s ease;
//         }

//         .logo:hover {
//           transform: translateY(-2px);
//         }

//         .logo-icon {
//           width: 55px;
//           height: 55px;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           font-weight: 800;
//           font-size: 1.5rem;
//           transition: all 0.3s ease;
//         }

//         .header.scrolled .logo-icon {
//           width: 45px;
//           height: 45px;
//           font-size: 1.2rem;
//         }

//         .logo-text h1 {
//           font-family: 'Playfair Display', serif;
//           font-size: 1.8rem;
//           font-weight: 700;
//           color: #1B4965;
//           line-height: 1.2;
//           transition: font-size 0.3s ease;
//         }

//         .header.scrolled .logo-text h1 {
//           font-size: 1.5rem;
//         }

//         .logo-text p {
//           font-size: 0.75rem;
//           color: #666;
//           font-weight: 500;
//           letter-spacing: 0.5px;
//         }

//         .nav {
//           display: flex;
//           align-items: center;
//           gap: 3rem;
//         }

//         .nav-links {
//           display: flex;
//           gap: 2.5rem;
//           list-style: none;
//           align-items: center;
//         }

//         .nav-item {
//           position: relative;
//         }

//         .nav-link {
//           color: #1B4965;
//           text-decoration: none;
//           font-weight: 600;
//           font-size: 0.95rem;
//           position: relative;
//           transition: color 0.3s ease;
//           letter-spacing: 0.3px;
//           display: flex;
//           align-items: center;
//           gap: 0.3rem;
//           cursor: pointer;
//           padding: 0.5rem 0;
//         }

//         .nav-link svg {
//           transition: transform 0.3s ease;
//         }

//         .nav-item:hover .nav-link svg,
//         .nav-item.active .nav-link svg {
//           transform: rotate(180deg);
//         }

//         .nav-link::after {
//           content: '';
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           width: 0;
//           height: 2px;
//           background: #E86A33;
//           transition: width 0.3s ease;
//         }

//         .nav-link:hover,
//         .nav-item.active .nav-link {
//           color: #E86A33;
//         }

//         .nav-link:hover::after,
//         .nav-item.active .nav-link::after {
//           width: 100%;
//         }

//         /* Dropdown Menu Styles */
//         .dropdown-menu {
//           position: absolute;
//           top: 100%;
//           left: 50%;
//           transform: translateX(-50%);
//           background: #2C85B8;
//           min-width: 250px;
//           border-radius: 0;
//           opacity: 0;
//           visibility: hidden;
//           transition: all 0.3s ease;
//           margin-top: 0.5rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
//           z-index: 1001;
//         }

//         .nav-item:hover .dropdown-menu,
//         .nav-item.active .dropdown-menu {
//           opacity: 1;
//           visibility: visible;
//           margin-top: 0;
//         }

//         .dropdown-item {
//           display: block;
//           padding: 1rem 1.5rem;
//           color: white;
//           text-decoration: none;
//           font-weight: 500;
//           font-size: 0.95rem;
//           border-bottom: 1px solid rgba(255, 255, 255, 0.1);
//           transition: all 0.3s ease;
//           background: transparent;
//         }

//         .dropdown-item:last-child {
//           border-bottom: none;
//         }

//         .dropdown-item:hover {
//           background: rgba(255, 255, 255, 0.1);
//           padding-left: 2rem;
//           color: #FFD700;
//         }

//         .cta-button {
//           padding: 0.8rem 2rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 600;
//           font-size: 0.95rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
//         }

//         .mobile-menu-btn {
//           display: none;
//           background: none;
//           border: none;
//           color: #1B4965;
//           cursor: pointer;
//           padding: 0.5rem;
//         }

//         .mobile-menu-overlay {
//           display: none;
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(0, 0, 0, 0.5);
//           z-index: 999;
//           opacity: 0;
//           transition: opacity 0.3s ease;
//         }

//         .mobile-menu-overlay.open {
//           display: block;
//           opacity: 1;
//         }

//         .mobile-menu {
//           position: fixed;
//           top: 0;
//           right: 0;
//           width: 100%;
//           max-width: 400px;
//           height: 100vh;
//           background: white;
//           box-shadow: -5px 0 30px rgba(0, 0, 0, 0.2);
//           z-index: 1000;
//           padding: 2rem;
//           transform: translateX(100%);
//           transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           overflow-y: auto;
//         }

//         .mobile-menu.open {
//           transform: translateX(0);
//         }

//         .mobile-menu-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 3rem;
//           padding-bottom: 1.5rem;
//           border-bottom: 2px solid #f0f0f0;
//         }

//         .mobile-nav-links {
//           display: flex;
//           flex-direction: column;
//           gap: 0;
//           list-style: none;
//           margin-bottom: 2rem;
//         }

//         .mobile-nav-link {
//           color: #1B4965;
//           text-decoration: none;
//           font-weight: 600;
//           font-size: 1.1rem;
//           padding: 1rem 0;
//           border-bottom: 1px solid #f0f0f0;
//           transition: all 0.3s ease;
//           display: block;
//         }

//         .mobile-nav-link:hover {
//           color: #E86A33;
//           padding-left: 0.5rem;
//         }

//         @media (max-width: 1024px) {
//           .nav-links {
//             display: none;
//           }

//           .nav .cta-button {
//             display: none;
//           }

//           .mobile-menu-btn {
//             display: block;
//           }
//         }

//         @media (max-width: 768px) {
//           .header-top-content {
//             justify-content: center;
//           }

//           .header-contact {
//             flex-direction: column;
//             gap: 0.5rem;
//             text-align: center;
//           }

//           .logo-text h1 {
//             font-size: 1.3rem;
//           }

//           .logo-icon {
//             width: 45px;
//             height: 45px;
//             font-size: 1.2rem;
//           }

//           .mobile-menu {
//             max-width: 100%;
//           }
//         }
//       `}</style>

//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="header-top">
//           <div className="header-top-content">
//             <div className="header-contact">
//               <div className="contact-item">
//                 <Phone size={16} />
//                 <span>+91 123 456 7890</span>
//               </div>
//               <div className="contact-item">
//                 <Mail size={16} />
//                 <span>info@vayulungcare.com</span>
//               </div>
//               <div className="contact-item">
//                 <MapPin size={16} />
//                 <span>Hyderabad, India</span>
//               </div>
//             </div>
//             <div className="header-contact">
//               <div className="contact-item">
//                 <Clock size={16} />
//                 <span>Mon-Sat: 9 AM - 8 PM</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="header-main">
//           <div className="header-content">
//             <a href="/" className="logo">
//               <div className="logo-icon">V</div>
//               <div className="logo-text">
//                 <h1>VAYU Lung Care</h1>
//                 <p>Multi-Speciality Clinics</p>
//               </div>
//             </a>

//             <nav className="nav">
//               <ul className="nav-links">
//                 <li className="nav-item">
//                   <a href="/about" className="nav-link">ABOUT US</a>
//                 </li>
                
//                 <li 
//                   className={`nav-item ${activeDropdown === 'services' ? 'active' : ''}`}
//                   onMouseEnter={() => setActiveDropdown('services')}
//                   onMouseLeave={() => setActiveDropdown(null)}
//                 >
//                   <span className="nav-link">
//                     SERVICES
//                     <ChevronDown size={16} />
//                   </span>
//                   <div className="dropdown-menu">
//                     {services.map((service, index) => (
//                       <a key={index} href={service.path} className="dropdown-item">
//                         {service.name}
//                       </a>
//                     ))}
//                   </div>
//                 </li>

//                 <li className="nav-item">
//                   <a href="/facilities" className="nav-link">FACILITIES</a>
//                 </li>

//                 <li 
//                   className={`nav-item ${activeDropdown === 'procedures' ? 'active' : ''}`}
//                   onMouseEnter={() => setActiveDropdown('procedures')}
//                   onMouseLeave={() => setActiveDropdown(null)}
//                 >
//                   <span className="nav-link">
//                     PROCEDURES
//                     <ChevronDown size={16} />
//                   </span>
//                   <div className="dropdown-menu">
//                     {procedures.map((procedure, index) => (
//                       <a key={index} href={procedure.path} className="dropdown-item">
//                         {procedure.name}
//                       </a>
//                     ))}
//                   </div>
//                 </li>
//               </ul>
//               <button className="cta-button">
//                 Book Appointment
//                 <ChevronRight size={18} />
//               </button>
//             </nav>

//             <button 
//               className="mobile-menu-btn" 
//               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             >
//               {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Mobile Menu Overlay */}
//       <div 
//         className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
//         onClick={() => setMobileMenuOpen(false)}
//       ></div>

//       {/* Mobile Menu */}
//       <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//         <div className="mobile-menu-header">
//           <div className="logo-text">
//             <h1 style={{fontSize: '1.5rem', color: '#1B4965', fontFamily: 'Playfair Display, serif'}}>VAYU Lung Care</h1>
//             <p style={{fontSize: '0.8rem', color: '#666'}}>Multi-Speciality Clinics</p>
//           </div>
//           <button 
//             style={{background: 'none', border: 'none', cursor: 'pointer', color: '#1B4965'}}
//             onClick={() => setMobileMenuOpen(false)}
//           >
//             <X size={28} />
//           </button>
//         </div>

//         <ul className="mobile-nav-links">
//           <li><a href="/about" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>About Us</a></li>
//           <li><a href="/services" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Services</a></li>
//           <li><a href="/facilities" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Facilities</a></li>
//           <li><a href="/procedures" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Procedures</a></li>
//           <li><a href="/contact" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Contact</a></li>
//         </ul>

//         <button className="cta-button" style={{width: '100%', justifyContent: 'center'}}>
//           Book Appointment
//           <ChevronRight size={18} />
//         </button>

//         <div style={{marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #f0f0f0'}}>
//           <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', color: '#666'}}>
//             <Phone size={18} />
//             <span>+91 123 456 7890</span>
//           </div>
//           <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', color: '#666'}}>
//             <Mail size={18} />
//             <span>info@vayulungcare.com</span>
//           </div>
//           <div style={{display: 'flex', alignItems: 'center', gap: '1rem', color: '#666'}}>
//             <MapPin size={18} />
//             <span>Hyderabad, India</span>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;



// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { ChevronRight, Phone, Mail, MapPin, Clock, Menu, X, ChevronDown } from 'lucide-react';
// import vayuLogo from './Images/vayu_logo.png';

// const Header = () => {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [activeDropdown, setActiveDropdown] = useState(null);

//   const services = [
//     { name: 'Chest X-Ray', path: '/services/chest-xray' },
//     { name: 'PFT', path: '/services/pft' },
//     { name: 'ECG', path: '/services/ecg' },
//     { name: '2D ECHO', path: '/services/2d-echo' },
//     { name: 'Allergy Testing', path: '/services/allergy-testing' },
//     { name: 'Bronchoscopy', path: '/services/bronchoscopy' },
//     { name: 'Thoracoscopy', path: '/services/thoracoscopy' }
//   ];

//   const procedures = [
//     { name: 'Asthma', path: '/procedures/asthma' },
//     { name: 'Allergies', path: '/procedures/allergies' },
//     { name: 'Snoring', path: '/procedures/snoring' },
//     { name: 'Adenoids', path: '/procedures/adenoids' },
//     { name: 'Tonsils', path: '/procedures/tonsils' },
//     { name: 'Sinusitis', path: '/procedures/sinusitis' },
//     { name: 'COPD', path: '/procedures/copd' },
//     { name: 'ILD', path: '/procedures/ild' },
//     { name: 'Obesity', path: '/procedures/obesity' },
//     { name: 'T.B', path: '/procedures/tb' },
//     { name: 'Lung Cancer', path: '/procedures/lung-cancer' },
//     // { name: 'Other Services On Request', path: '/procedures/other-services' }
//   ];

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
//         :root {
//           --primary-orange: #E86A33;
//           --primary-blue: #1B4965;
//           --accent-blue: #2C5F7C;
//           --light-blue: #62B6CB;
//           --orange-light: #FF9B6E;
//           --text-dark: #1a1a1a;
//           --text-light: #666;
//           --bg-light: #F8FAFB;
//         }

//         .header {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           z-index: 1000;
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           background: white;
//           box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
//         }

//         .header.scrolled {
//           background: rgba(255, 255, 255, 0.98);
//           backdrop-filter: blur(20px);
//           box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
//         }

//         .header-top {
//           background: linear-gradient(135deg, #1B4965, #2C5F7C);
//           padding: 0.8rem 0;
//           color: white;
//           font-size: 0.85rem;
//         }

//         .header.scrolled .header-top {
//           display: none;
//         }

//         .header-top-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           flex-wrap: wrap;
//           gap: 1rem;
//         }

//         .header-contact {
//           display: flex;
//           gap: 2rem;
//           align-items: center;
//         }

//         .contact-item {
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         .header-main {
//           padding: 1.2rem 0;
//           transition: padding 0.4s ease;
//         }

//         .header.scrolled .header-main {
//           padding: 0.8rem 0;
//         }

//         .header-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//         }

//         .logo {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           text-decoration: none;
//           transition: transform 0.3s ease;
//         }

//         .logo:hover {
//           transform: translateY(-2px);
//         }
//         .logo:hover {
//   transform: translateY(-2px);
// }

// /* Add this new CSS block here */
// .logo-image {
//   height: 80px;
//   width: auto;
//   object-fit: contain;
//   transition: all 0.3s ease;
// }

// .header.scrolled .logo-image {
//   height: 60px;
// }



//         .logo-icon {
//           width: 55px;
//           height: 55px;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           font-weight: 800;
//           font-size: 1.5rem;
//           transition: all 0.3s ease;
//         }

//         .header.scrolled .logo-icon {
//           width: 45px;
//           height: 45px;
//           font-size: 1.2rem;
//         }

//         .logo-text h1 {
//           font-family: 'Playfair Display', serif;
//           font-size: 1.8rem;
//           font-weight: 700;
//           color: #1B4965;
//           line-height: 1.2;
//           transition: font-size 0.3s ease;
//         }

//         .header.scrolled .logo-text h1 {
//           font-size: 1.5rem;
//         }

//         .logo-text p {
//           font-size: 0.75rem;
//           color: #666;
//           font-weight: 500;
//           letter-spacing: 0.5px;
//         }

//         .nav {
//           display: flex;
//           align-items: center;
//           gap: 3rem;
//         }

//         .nav-links {
//           display: flex;
//           gap: 2.5rem;
//           list-style: none;
//           align-items: center;
//         }

//         .nav-item {
//           position: relative;
//         }

//         .nav-link {
//           color: #1B4965;
//           text-decoration: none;
//           font-weight: 600;
//           font-size: 0.95rem;
//           position: relative;
//           transition: color 0.3s ease;
//           letter-spacing: 0.3px;
//           display: flex;
//           align-items: center;
//           gap: 0.3rem;
//           cursor: pointer;
//           padding: 0.5rem 0;
//         }

//         .nav-link svg {
//           transition: transform 0.3s ease;
//         }

//         .nav-item:hover .nav-link svg,
//         .nav-item.active .nav-link svg {
//           transform: rotate(180deg);
//         }

//         .nav-link::after {
//           content: '';
//           position: absolute;
//           bottom: 0;
//           left: 0;
//           width: 0;
//           height: 2px;
//           background: #E86A33;
//           transition: width 0.3s ease;
//         }

//         .nav-link:hover,
//         .nav-item.active .nav-link {
//           color: #E86A33;
//         }

//         .nav-link:hover::after,
//         .nav-item.active .nav-link::after {
//           width: 100%;
//         }

//         /* Dropdown Menu Styles */
//         .dropdown-menu {
//           position: absolute;
//           top: 100%;
//           left: 50%;
//           transform: translateX(-50%);
//           background: #2C85B8;
//           min-width: 250px;
//           border-radius: 0;
//           opacity: 0;
//           visibility: hidden;
//           transition: all 0.3s ease;
//           margin-top: 0.5rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
//           z-index: 1001;
//         }

//         .nav-item:hover .dropdown-menu,
//         .nav-item.active .dropdown-menu {
//           opacity: 1;
//           visibility: visible;
//           margin-top: 0;
//         }

//         .dropdown-item {
//           display: block;
//           padding: 1rem 1.5rem;
//           color: white;
//           text-decoration: none;
//           font-weight: 500;
//           font-size: 0.95rem;
//           border-bottom: 1px solid rgba(255, 255, 255, 0.1);
//           transition: all 0.3s ease;
//           background: transparent;
//         }

//         .dropdown-item:last-child {
//           border-bottom: none;
//         }

//         .dropdown-item:hover {
//           background: rgba(255, 255, 255, 0.1);
//           padding-left: 2rem;
//           color: #FFD700;
//         }

//         .cta-button {
//           padding: 0.8rem 2rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 600;
//           font-size: 0.95rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
//         }

//         .cta-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
//         }

//         .mobile-menu-btn {
//           display: none;
//           background: none;
//           border: none;
//           color: #1B4965;
//           cursor: pointer;
//           padding: 0.5rem;
//         }

//         .mobile-menu-overlay {
//           display: none;
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(0, 0, 0, 0.5);
//           z-index: 999;
//           opacity: 0;
//           transition: opacity 0.3s ease;
//         }

//         .mobile-menu-overlay.open {
//           display: block;
//           opacity: 1;
//         }

//         .mobile-menu {
//           position: fixed;
//           top: 0;
//           right: 0;
//           width: 100%;
//           max-width: 400px;
//           height: 100vh;
//           background: white;
//           box-shadow: -5px 0 30px rgba(0, 0, 0, 0.2);
//           z-index: 1000;
//           padding: 2rem;
//           transform: translateX(100%);
//           transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           overflow-y: auto;
//         }

//         .mobile-menu.open {
//           transform: translateX(0);
//         }

//         .mobile-menu-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 3rem;
//           padding-bottom: 1.5rem;
//           border-bottom: 2px solid #f0f0f0;
//         }

//         .mobile-nav-links {
//           display: flex;
//           flex-direction: column;
//           gap: 0;
//           list-style: none;
//           margin-bottom: 2rem;
//         }

//         .mobile-nav-link {
//           color: #1B4965;
//           text-decoration: none;
//           font-weight: 600;
//           font-size: 1.1rem;
//           padding: 1rem 0;
//           border-bottom: 1px solid #f0f0f0;
//           transition: all 0.3s ease;
//           display: block;
//         }

//         .mobile-nav-link:hover {
//           color: #E86A33;
//           padding-left: 0.5rem;
//         }

//         @media (max-width: 1024px) {
//           .nav-links {
//             display: none;
//           }

//           .nav .cta-button {
//             display: none;
//           }

//           .mobile-menu-btn {
//             display: block;
//           }
//         }

//         @media (max-width: 768px) {
//           .header-top-content {
//             justify-content: center;
//           }

//           .header-contact {
//             flex-direction: column;
//             gap: 0.5rem;
//             text-align: center;
//           }

//           .logo-text h1 {
//             font-size: 1.3rem;
//           }

//           .logo-icon {
//             width: 45px;
//             height: 45px;
//             font-size: 1.2rem;
//           }

//           .mobile-menu {
//             max-width: 100%;
//           }
//             @media (max-width: 768px) {
//   .logo-image {
//     height: 55px;
//   }
  
//   .header.scrolled .logo-image {
//     height: 45px;
//   }
// }

//         }
//       `}</style>

//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="header-top">
//           <div className="header-top-content">
//             <div className="header-contact">
//               <div className="contact-item">
//                 <Phone size={16} />
//                 <span>+91 9989162222</span>
//               </div>
//               <div className="contact-item">
//                 <Mail size={16} />
//                 <span>vayulungcare@gmail.com</span>
//               </div>
//               <div className="contact-item">
//                 <MapPin size={16} />
//                 <span>Hyderabad, India</span>
//               </div>
//             </div>
//             <div className="header-contact">
//               <div className="contact-item">
//                 <Clock size={16} />
//                 <span>Mon-Sat: 9:00 AM - 9:00 PM,</span>

//                  <span>Sunday: 9:00 AM - 1:00 PM</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="header-main">
//           <div className="header-content">
//             {/* <Link to="/" className="logo">
//               <div className="logo-icon">V</div>
//               <div className="logo-text">
//                 <h1>VAYU Lung Care</h1>
//                 <p>Multi-Speciality Clinics</p>
//               </div>
//             </Link> */}
//             <Link to="/" className="logo">
//   <img src={vayuLogo} alt="VAYU Lung Care - Multi-Speciality Clinics" className="logo-image" />
// </Link>

//             <nav className="nav">
//               <ul className="nav-links">
//                 <li className="nav-item">
//                   <Link to="/" className="nav-link">Home</Link>
//                 </li>
                
//                 <li 
//                   className={`nav-item ${activeDropdown === 'procedures' ? 'active' : ''}`}
//                   onMouseEnter={() => setActiveDropdown('procedures')}
//                   onMouseLeave={() => setActiveDropdown(null)}
//                 >

//                   <span className="nav-link">
//                     Services
//                     <ChevronDown size={16} />
//                   </span>
//                   <div className="dropdown-menu">
//                     {procedures.map((procedure, index) => (
//                       <Link key={index} to={procedure.path} className="dropdown-item">
//                         {procedure.name}
//                       </Link>
//                     ))}
//                   </div>
//                 </li>
                
//                 <li 
//                   className={`nav-item ${activeDropdown === 'services' ? 'active' : ''}`}
//                   onMouseEnter={() => setActiveDropdown('services')}
//                   onMouseLeave={() => setActiveDropdown(null)}
//                 >
//                   <span className="nav-link">
//                     Procedures
//                     <ChevronDown size={16} />
//                   </span>
//                   <div className="dropdown-menu">
//                     {services.map((service, index) => (
//                       <Link key={index} to={service.path} className="dropdown-item">
//                         {service.name}
//                       </Link>
//                     ))}
//                   </div>
//                 </li>

//                 {/* <li className="nav-item">
//                   <Link to="/facilities" className="nav-link">FACILITIES</Link>
//                 </li> */}

//                 <li className="nav-item">
//                   <Link to="/contact" className="nav-link">Contact Us</Link>
//                 </li>
//               </ul>
//               <button className="cta-button">
//                 Book Appointment
//                 <ChevronRight size={18} />
//               </button>
//             </nav>

//             <button 
//               className="mobile-menu-btn" 
//               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             >
//               {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Mobile Menu Overlay */}
//       <div 
//         className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
//         onClick={() => setMobileMenuOpen(false)}
//       ></div>

//       {/* Mobile Menu */}
//       <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//         <div className="mobile-menu-header">
//           <div className="logo-text">
//             <h1 style={{fontSize: '1.5rem', color: '#1B4965', fontFamily: 'Playfair Display, serif'}}>VAYU Lung Care</h1>
//             <p style={{fontSize: '0.8rem', color: '#666'}}>Multi-Speciality Clinics</p>
//           </div>
//           <button 
//             style={{background: 'none', border: 'none', cursor: 'pointer', color: '#1B4965'}}
//             onClick={() => setMobileMenuOpen(false)}
//           >
//             <X size={28} />
//           </button>
//         </div>

//         <ul className="mobile-nav-links">
//           <li><Link to="/about" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>About Us</Link></li>
//           <li><Link to="/services" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Services</Link></li>
//           <li><Link to="/facilities" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Facilities</Link></li>
//           <li><Link to="/procedures" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Procedures</Link></li>
//           <li><Link to="/contact" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Contact</Link></li>
//         </ul>

//         <button className="cta-button" style={{width: '100%', justifyContent: 'center'}}>
//           Book Appointment
//           <ChevronRight size={18} />
//         </button>

//         <div style={{marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #f0f0f0'}}>
//           <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', color: '#666'}}>
//             <Phone size={18} />
//             <span>+91 123 456 7890</span>
//           </div>
//           <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', color: '#666'}}>
//             <Mail size={18} />
//             <span>info@vayulungcare.com</span>
//           </div>
//           <div style={{display: 'flex', alignItems: 'center', gap: '1rem', color: '#666'}}>
//             <MapPin size={18} />
//             <span>Hyderabad, India</span>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Header;


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Phone, Mail, MapPin, Clock, Menu, X, ChevronDown } from 'lucide-react';
import vayuLogo from './Images/vayu_logo.png';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileProceduresOpen, setMobileProceduresOpen] = useState(false);

  const services = [
    { name: 'Chest X-Ray', path: '/services/chest-xray' },
    { name: 'PFT', path: '/services/pft' },
    { name: 'ECG', path: '/services/ecg' },
    { name: '2D ECHO', path: '/services/2d-echo' },
    { name: 'Allergy Testing', path: '/services/allergy-testing' },
    { name: 'Bronchoscopy', path: '/services/bronchoscopy' },
    { name: 'Thoracoscopy', path: '/services/thoracoscopy' }
  ];

  const procedures = [
    { name: 'Asthma', path: '/procedures/asthma' },
    { name: 'Allergies', path: '/procedures/allergies' },
    { name: 'Snoring', path: '/procedures/snoring' },
    { name: 'Adenoids', path: '/procedures/adenoids' },
    { name: 'Tonsils', path: '/procedures/tonsils' },
    { name: 'Sinusitis', path: '/procedures/sinusitis' },
    { name: 'COPD', path: '/procedures/copd' },
    { name: 'ILD', path: '/procedures/ild' },
    { name: 'Obesity', path: '/procedures/obesity' },
    { name: 'T.B', path: '/procedures/tb' },
    { name: 'Lung Cancer', path: '/procedures/lung-cancer' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
        :root {
          --primary-orange: #E86A33;
          --primary-blue: #1B4965;
          --accent-blue: #2C5F7C;
          --light-blue: #62B6CB;
          --orange-light: #FF9B6E;
          --text-dark: #1a1a1a;
          --text-light: #666;
          --bg-light: #F8FAFB;
        }

        .header {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          background: white;
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
        }

        .header.scrolled {
          background: rgba(255, 255, 255, 0.98);
          backdrop-filter: blur(20px);
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        }

        .header-top {
          background: linear-gradient(135deg, #1B4965, #2C5F7C);
          padding: 0.8rem 0;
          color: white;
          font-size: 0.85rem;
        }

        .header.scrolled .header-top {
          display: none;
        }

        .header-top-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        }

        .header-contact {
          display: flex;
          gap: 2rem;
          align-items: center;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .header-main {
          padding: 1.2rem 0;
          transition: padding 0.4s ease;
        }

        .header.scrolled .header-main {
          padding: 0.8rem 0;
        }

        .header-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          display: flex;
          align-items: center;
          gap: 1rem;
          text-decoration: none;
          transition: transform 0.3s ease;
        }

        .logo:hover {
          transform: translateY(-2px);
        }

        .logo-image {
          height: 80px;
          width: auto;
          object-fit: contain;
          transition: all 0.3s ease;
        }

        .header.scrolled .logo-image {
          height: 60px;
        }

        .logo-icon {
          width: 55px;
          height: 55px;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 800;
          font-size: 1.5rem;
          transition: all 0.3s ease;
        }

        .header.scrolled .logo-icon {
          width: 45px;
          height: 45px;
          font-size: 1.2rem;
        }

        .logo-text h1 {
          font-family: 'Playfair Display', serif;
          font-size: 1.8rem;
          font-weight: 700;
          color: #1B4965;
          line-height: 1.2;
          transition: font-size 0.3s ease;
        }

        .header.scrolled .logo-text h1 {
          font-size: 1.5rem;
        }

        .logo-text p {
          font-size: 0.75rem;
          color: #666;
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        .nav {
          display: flex;
          align-items: center;
          gap: 3rem;
        }

        .nav-links {
          display: flex;
          gap: 2.5rem;
          list-style: none;
          align-items: center;
        }

        .nav-item {
          position: relative;
        }

        .nav-link {
          color: #1B4965;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.95rem;
          position: relative;
          transition: color 0.3s ease;
          letter-spacing: 0.3px;
          display: flex;
          align-items: center;
          gap: 0.3rem;
          cursor: pointer;
          padding: 0.5rem 0;
        }

        .nav-link svg {
          transition: transform 0.3s ease;
        }

        .nav-item:hover .nav-link svg,
        .nav-item.active .nav-link svg {
          transform: rotate(180deg);
        }

        .nav-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: #E86A33;
          transition: width 0.3s ease;
        }

        .nav-link:hover,
        .nav-item.active .nav-link {
          color: #E86A33;
        }

        .nav-link:hover::after,
        .nav-item.active .nav-link::after {
          width: 100%;
        }

        /* Dropdown Menu Styles */
        .dropdown-menu {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          background: #2C85B8;
          min-width: 250px;
          border-radius: 0;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          margin-top: 0.5rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
          z-index: 1001;
        }

        .nav-item:hover .dropdown-menu,
        .nav-item.active .dropdown-menu {
          opacity: 1;
          visibility: visible;
          margin-top: 0;
        }

        .dropdown-item {
          display: block;
          padding: 1rem 1.5rem;
          color: white;
          text-decoration: none;
          font-weight: 500;
          font-size: 0.95rem;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          transition: all 0.3s ease;
          background: transparent;
        }

        .dropdown-item:last-child {
          border-bottom: none;
        }

        .dropdown-item:hover {
          background: rgba(255, 255, 255, 0.1);
          padding-left: 2rem;
          color: #FFD700;
        }

        .cta-button {
          padding: 0.8rem 2rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 600;
          font-size: 0.95rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
          text-decoration: none;
        }

        .cta-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
        }

        .mobile-menu-btn {
          display: none;
          background: none;
          border: none;
          color: #1B4965;
          cursor: pointer;
          padding: 0.5rem;
        }

        .mobile-menu-overlay {
          display: none;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 999;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .mobile-menu-overlay.open {
          display: block;
          opacity: 1;
        }

        .mobile-menu {
          position: fixed;
          top: 0;
          right: 0;
          width: 100%;
          max-width: 400px;
          height: 100vh;
          background: white;
          box-shadow: -5px 0 30px rgba(0, 0, 0, 0.2);
          z-index: 1000;
          padding: 2rem;
          transform: translateX(100%);
          transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          overflow-y: auto;
        }

        .mobile-menu.open {
          transform: translateX(0);
        }

        .mobile-menu-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 3rem;
          padding-bottom: 1.5rem;
          border-bottom: 2px solid #f0f0f0;
        }

        .mobile-nav-links {
          display: flex;
          flex-direction: column;
          gap: 0;
          list-style: none;
          margin-bottom: 2rem;
        }

        .mobile-nav-link {
          color: #1B4965;
          text-decoration: none;
          font-weight: 600;
          font-size: 1.1rem;
          padding: 1rem 0;
          border-bottom: 1px solid #f0f0f0;
          transition: all 0.3s ease;
          display: block;
        }

        .mobile-nav-link:hover {
          color: #E86A33;
          padding-left: 0.5rem;
        }

        .mobile-dropdown-header {
          color: #1B4965;
          font-weight: 600;
          font-size: 1.1rem;
          padding: 1rem 0;
          border-bottom: 1px solid #f0f0f0;
          transition: all 0.3s ease;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
        }

        .mobile-dropdown-header:hover {
          color: #E86A33;
        }

        .mobile-dropdown-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
        }

        .mobile-dropdown-content.open {
          max-height: 1000px;
        }

        .mobile-dropdown-item {
          display: block;
          padding: 0.8rem 0 0.8rem 1.5rem;
          color: #666;
          text-decoration: none;
          font-size: 0.95rem;
          font-weight: 500;
          transition: all 0.3s ease;
          border-bottom: 1px solid #f5f5f5;
        }

        .mobile-dropdown-item:hover {
          color: #E86A33;
          padding-left: 2rem;
          background: #f8f8f8;
        }

        @media (max-width: 1024px) {
          .nav-links {
            display: none;
          }

          .nav .cta-button {
            display: none;
          }

          .mobile-menu-btn {
            display: block;
          }
        }

        @media (max-width: 768px) {
          .header-top-content {
            justify-content: center;
          }

          .header-contact {
            flex-direction: column;
            gap: 0.5rem;
            text-align: center;
          }

          .logo-text h1 {
            font-size: 1.3rem;
          }

          .logo-icon {
            width: 45px;
            height: 45px;
            font-size: 1.2rem;
          }

          .mobile-menu {
            max-width: 100%;
          }

          .logo-image {
            height: 55px;
          }
          
          .header.scrolled .logo-image {
            height: 45px;
          }
        }
      `}</style>

      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-top">
          <div className="header-top-content">
            <div className="header-contact">
              <div className="contact-item">
                <Phone size={16} />
                <span>+91 9989162222</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>vayulungcare@gmail.com</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Hyderabad, India</span>
              </div>
            </div>
            <div className="header-contact">
              <div className="contact-item">
                <Clock size={16} />
                <span>Mon-Sat: 9:00 AM - 9:00 PM,</span>
                <span>Sunday: 9:00 AM - 1:00 PM</span>
              </div>
            </div>
          </div>
        </div>

        <div className="header-main">
          <div className="header-content">
            <Link to="/" className="logo">
              <img src={vayuLogo} alt="VAYU Lung Care - Multi-Speciality Clinics" className="logo-image" />
            </Link>

            <nav className="nav">
              <ul className="nav-links">
                <li className="nav-item">
                  <Link to="/" className="nav-link">Home</Link>
                </li>
                
                <li 
                  className={`nav-item ${activeDropdown === 'procedures' ? 'active' : ''}`}
                  onMouseEnter={() => setActiveDropdown('procedures')}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <span className="nav-link">
                    Services
                    <ChevronDown size={16} />
                  </span>
                  <div className="dropdown-menu">
                    {procedures.map((procedure, index) => (
                      <Link key={index} to={procedure.path} className="dropdown-item">
                        {procedure.name}
                      </Link>
                    ))}
                  </div>
                </li>
                
                <li 
                  className={`nav-item ${activeDropdown === 'services' ? 'active' : ''}`}
                  onMouseEnter={() => setActiveDropdown('services')}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  <span className="nav-link">
                    Procedures
                    <ChevronDown size={16} />
                  </span>
                  <div className="dropdown-menu">
                    {services.map((service, index) => (
                      <Link key={index} to={service.path} className="dropdown-item">
                        {service.name}
                      </Link>
                    ))}
                  </div>
                </li>

                <li className="nav-item">
                  <Link to="/contact" className="nav-link">Contact Us</Link>
                </li>
              </ul>
              <Link to="/contact" className="cta-button" style={{textDecoration: 'none'}}>
                Book Appointment
                <ChevronRight size={18} />
              </Link>
            </nav>

            <button 
              className="mobile-menu-btn" 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div 
        className={`mobile-menu-overlay ${mobileMenuOpen ? 'open' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <div className="logo-text">
            <h1 style={{fontSize: '1.5rem', color: '#1B4965', fontFamily: 'Playfair Display, serif'}}>VAYU Lung Care</h1>
            <p style={{fontSize: '0.8rem', color: '#666'}}>Multi-Speciality Clinics</p>
          </div>
          <button 
            style={{background: 'none', border: 'none', cursor: 'pointer', color: '#1B4965'}}
            onClick={() => setMobileMenuOpen(false)}
          >
            <X size={28} />
          </button>
        </div>

        <ul className="mobile-nav-links">
          <li><Link to="/" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Home</Link></li>
          
          {/* Services Dropdown */}
          <li>
            <div 
              className="mobile-dropdown-header"
              onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
            >
              <span>Services</span>
              <ChevronDown 
                size={20} 
                style={{
                  transform: mobileServicesOpen ? 'rotate(180deg)' : 'rotate(0)',
                  transition: 'transform 0.3s ease'
                }}
              />
            </div>
            <div className={`mobile-dropdown-content ${mobileServicesOpen ? 'open' : ''}`}>
              {procedures.map((procedure, index) => (
                <Link 
                  key={index} 
                  to={procedure.path} 
                  className="mobile-dropdown-item" 
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {procedure.name}
                </Link>
              ))}
            </div>
          </li>

          {/* Procedures Dropdown */}
          <li>
            <div 
              className="mobile-dropdown-header"
              onClick={() => setMobileProceduresOpen(!mobileProceduresOpen)}
            >
              <span>Procedures</span>
              <ChevronDown 
                size={20} 
                style={{
                  transform: mobileProceduresOpen ? 'rotate(180deg)' : 'rotate(0)',
                  transition: 'transform 0.3s ease'
                }}
              />
            </div>
            <div className={`mobile-dropdown-content ${mobileProceduresOpen ? 'open' : ''}`}>
              {services.map((service, index) => (
                <Link 
                  key={index} 
                  to={service.path} 
                  className="mobile-dropdown-item" 
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {service.name}
                </Link>
              ))}
            </div>
          </li>

          <li><Link to="/contact" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link></li>
        </ul>

        <Link to="/contact" className="cta-button" style={{width: '100%', justifyContent: 'center', textDecoration: 'none'}} onClick={() => setMobileMenuOpen(false)}>
          Book Appointment
          <ChevronRight size={18} />
        </Link>

        <div style={{marginTop: '2rem', paddingTop: '2rem', borderTop: '2px solid #f0f0f0'}}>
          <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', color: '#666'}}>
            <Phone size={18} />
            <span>+91 9989162222</span>
          </div>
          <div style={{display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', color: '#666'}}>
            <Mail size={18} />
            <span>vayulungcare@gmail.com</span>
          </div>
          <div style={{display: 'flex', alignItems: 'center', gap: '1rem', color: '#666'}}>
            <MapPin size={18} />
            <span>Hyderabad, India</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;